module.exports = __webpack_public_path__ + "static/team-default-610d3a6ed302fc0b4a3a13b9d0378cef.jpg";